import React, { useEffect, useRef, useState } from "react";

const JewelryCarouselSection = () => {
    const items = [
        { id: 1, img: "/assets/images/aboutus/aboutus_carousel1.jpg" },
        { id: 2, img: "/assets/images/aboutus/aboutus_carousel2.jpg" },
        { id: 3, img: "/assets/images/aboutus/aboutus_carousel3.jpg" },
    ];

    const [perView, setPerView] = useState(() => {
        if (typeof window !== "undefined") {
            const width = window.innerWidth;
            if (width < 640) return 1;
            if (width < 1024) return 2;
        }
        return 3; 
    });

    const [index, setIndex] = useState(perView);
    const autoMs = 3000;

    const viewportRef = useRef(null);
    const [transitioning, setTransitioning] = useState(true);
    const [hover, setHover] = useState(false);

    const slides = [
        ...items.slice(-perView),
        ...items,
        ...items.slice(0, perView),
    ];

    const updatePerView = () => {
        const width = window.innerWidth;
        if (width < 640) {
            setPerView(1);
        } else if (width < 1024) {
            setPerView(2);
        } else {
            setPerView(3);
        }
    };

    useEffect(() => {
        updatePerView();
        const handleResize = () => updatePerView();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setIndex(perView);
    }, [perView]);

    const next = () => setIndex((i) => i + 1);
    const prev = () => setIndex((i) => i - 1);

    useEffect(() => {
        if (hover) return;
        const id = setInterval(next, autoMs);
        return () => clearInterval(id);
    }, [hover, perView]);

    useEffect(() => {
        if (index === slides.length - perView) {
            setTimeout(() => {
                setTransitioning(false);
                setIndex(perView);
            }, 600);
        }
        if (index === 0) {
            setTimeout(() => {
                setTransitioning(false);
                setIndex(slides.length - perView * 2);
            }, 600);
        }
    }, [index, slides.length, perView]);

    useEffect(() => {
        if (!transitioning) {
            const id = setTimeout(() => setTransitioning(true), 50);
            return () => clearTimeout(id);
        }
    }, [transitioning]);

    return (
        <div className="jewelrycarousel-section-container px-2">
            <div
                className="jc-root"
                data-aos="fade-down"
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <button className="jc-arrow jc-left" onClick={prev} aria-label="Previous">
                    <svg viewBox="0 0 24 24" width="80" height="80" stroke="gray" fill="none" strokeWidth="0.5">
                        <path d="M15 18l-6-6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                <div className="jc-viewport" ref={viewportRef}>
                    <div
                        className="jc-track"
                        style={{
                            transform: `translateX(-${index * (100 / perView)}%)`,
                            transition: transitioning ? "transform 0.6s ease" : "none",
                            "--per-view": perView
                        }}
                    >
                        {slides.map((it, idx) => (
                            <div className="jc-slide" key={idx}>
                                <div className="jc-card">
                                    <img src={it.img} alt={`jewelry-${it.id}`} loading="lazy" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button className="jc-arrow jc-right" onClick={next} aria-label="Next">
                    <svg viewBox="0 0 24 24" width="80" height="80" stroke="gray" fill="none" strokeWidth="0.5">
                        <path d="M9 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>

                <div className="jc-indicators">
                    {items.map((_, i) => (
                        <button
                            key={i}
                            className={`jc-indicator ${(index - perView) % items.length === i ? "active" : ""}`}
                            onClick={() => setIndex(i + perView)}
                            aria-label={`Go to slide ${i + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default JewelryCarouselSection;

